// Overview Entity Reducer

export default function reducer(state = {}, action = {}) {
    switch (action.type) {
        default:
            return state;
    }
}